import { Component } from '@angular/core';

@Component({
  selector: 'app-create-sale',
  template: ``,
  styleUrls: []
})
export class CreateSaleComponent {

}
